import { ListingModelesPageFiltre } from '@components/listing-modeles-page-filtre/models';
import { listingModelesPageFiltreMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';
import { Block } from '@shared/models';

const blocks: Block<unknown>[] = [];

export const lpSemPageFiltreMock = (params: ListingModelesPageFiltre): SlugPage => ({
  ...pageBase({
    title: 'LP sem - Page Filtre',
    type: 'lp-sem',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks: [...blocks, listingModelesPageFiltreMock(params)],
});
